import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import DispatchHistoryView from "./DispatchHistoryView";
import ReceivedHistoryView from "./ReceivedHistoryView";
import NoReceivedHistory from "./NoReceivedHistory";
import NoHistoryView from "../../NoHistoryView";
import CylinderHistoryDialog from "../CylinderHistoryDialog";
import Modal from "../../../../../../components/portal/Modal";

const CylinderHistoryList = () => {
  const { transport_history } = useSelector((state) => state.data.data);
  const [dialogDetails, setDialogDetails] = useState({});
  const [activeDialog, setActiveDialog] = useState(null);
  const [clickedImage, setClickedImage] = useState(null);

  // --- View Handlers ---

  const handleDialogClick = useCallback((data, state) => {
    setDialogDetails({ data, state });
    setActiveDialog("history");
  }, []);

  const handleImageView = (picture) => {
    setClickedImage(picture);
    setActiveDialog("imageView");
  };

  const handleCloseImageView = () => {
    setActiveDialog("history");
  };

  return (
    <>
      {transport_history.length !== 0 ? (
        <div className="pl-3 max-h-[calc(100%-100px)] overflow-auto hides-scrollbar">
          {transport_history.map((item) => {
            return (
              <React.Fragment key={item.id}>
                <DispatchHistoryView
                  item={item}
                  type="Dispatched"
                  onDialogClick={handleDialogClick}
                />
                {item.receivedAtStation ? (
                  <ReceivedHistoryView
                    item={item}
                    type="Received"
                    onDialogClick={handleDialogClick}
                  />
                ) : (
                  <NoReceivedHistory />
                )}
              </React.Fragment>
            );
          })}
        </div>
      ) : (
        <NoHistoryView msg="No Cylinder History Available..!" />
      )}
      {activeDialog === "history" && (
        <CylinderHistoryDialog
          dialogDetails={dialogDetails}
          close={() => setActiveDialog(null)}
          handleImageView={handleImageView}
        />
      )}

      {/* ------------------------------- Cylinder Image view --------------------------------- */}
      {activeDialog === "imageView" && (
        <Modal onClose={handleCloseImageView} modalWidth="max-w-xl w-11/12 p-4">
          <img src={clickedImage} alt="cylinder" className="w-full" />
        </Modal>
      )}
    </>
  );
};

export default CylinderHistoryList;
